import {
    Container,
    Row,
    Col,
    Button
} from "reactstrap";

import {
    FiArrowRight,
    FiBookOpen
} from "react-icons/fi";

import "./MoreCourses.css";

function MoreCourses({
    courses = []
}) {

    if (!courses.length) {
        return null;
    }

    return (
        <section className="more-courses">

            <Container>

                {/* Section Header */}

                <div className="more-courses-header">

                    <span className="more-courses-label">
                        MORE COURSES
                    </span>

                    <h2>
                        You might also{" "}
                        <strong>be interested</strong>{" "}
                        in these courses
                    </h2>

                    <p>
                        Explore our other specialized courses and
                        expand your skills with industry-focused training.
                    </p>

                </div>


                {/* Course Cards */}

                <Row className="g-4">

                    {courses.map((course, index) => (

                        <Col
                            lg="4"
                            md="6"
                            sm="12"
                            key={course.id || index}
                        >

                            <div className="more-course-card">

                                <div className="more-course-icon">
                                    <FiBookOpen />
                                </div>


                                <div className="more-course-content">

                                    <span className="more-course-name">
                                        {course.name}
                                    </span>

                                    <h3>
                                        {course.title}
                                    </h3>

                                    <p>
                                        {course.description}
                                    </p>

                                </div>


                                <div className="more-course-footer">

                                    <Button
                                        href={course.url}
                                        className="more-course-button"
                                    >
                                        View Course
                                        <FiArrowRight />
                                    </Button>

                                </div>

                            </div>

                        </Col>

                    ))}

                </Row>

            </Container>

        </section>
    );
}

export default MoreCourses;